import { forwardRef } from 'react';
// eslint-disable-next-line import/no-namespace
import * as Carousel from '@mweb/zappos-ui/Carousel';
import { UtilityStrokeCaretLeftMediumIcon, UtilityStrokeCaretRightMediumIcon } from '@mweb/zappos-ui/Icons';

import { cn } from 'helpers/classnames';
import type { ProductCarouselProps } from 'components/common/ProductCarousel/ProductCarousel.types';
import { backButton, forwardButton, item, root } from 'components/common/ProductCarousel/ProductCarousel.classes';
import { getTestId } from 'utils/testing';
import CaretLeftIcon from 'components/common/IconsV2/CaretLeftIcon';
import CaretRightIcon from 'components/common/IconsV2/CaretRightIcon';

export const ProductCarousel = forwardRef<HTMLDivElement, React.ComponentProps<typeof Carousel.Root> & ProductCarouselProps>((props, ref) => {
  const { options = {}, overrides = {}, slides, testId = '', backButtonOnClick, forwardButtonOnClick, ...rest } = props;

  return (
    <Carousel.Root ref={ref} options={options} className={cn(root, overrides.root)} data-testid={getTestId(testId, 'root')} {...rest}>
      <Carousel.Viewport className={cn(overrides.viewport)} data-testid={getTestId(testId, 'viewport')}>
        <Carousel.Items className={cn(overrides.items)} data-testid={getTestId(testId, 'items')}>
          {slides.map((slide, i) => (
            <Carousel.Item key={i} className={cn(item, overrides.item)} data-testid={getTestId(testId, `item-${i + 1}`)}>
              {slide}
            </Carousel.Item>
          ))}
        </Carousel.Items>

        <Carousel.Back className={cn(backButton, overrides.backButton)} data-testid={getTestId(testId, 'back')} onClick={backButtonOnClick}>
          <UtilityStrokeCaretLeftMediumIcon size={32} className="lumon:hidden" /> {/* the old one, hide when lumon is active. */}
          <CaretLeftIcon size={32} className="not-lumon:hidden" /> {/* the new one, hide when lumon is not active */}
        </Carousel.Back>

        <Carousel.Forward
          className={cn(forwardButton, overrides.forwardButton)}
          data-testid={getTestId(testId, 'forward')}
          onClick={forwardButtonOnClick}
        >
          <UtilityStrokeCaretRightMediumIcon size={32} className="lumon:hidden" /> {/* the old one, hide when lumon is active. */}
          <CaretRightIcon size={32} className="not-lumon:hidden" /> {/* the new one, hide when lumon is not active */}
        </Carousel.Forward>
      </Carousel.Viewport>
    </Carousel.Root>
  );
});
